<template>
  <div>
    <div class="flex items-center">
      <h4
        class="flex-shrink-0 pr-4 font-bebas tracking-wider text-lg leading-5 tracking-wider uppercase text-gray-600"
      >
        Related Tutorials
      </h4>
      <div class="flex-1 border-t-2 border-green" />
    </div>
    <div class="grid grid-cols-4 gap-6 mt-4 ">
      <div v-for="(tutorial, idx) in session.tutorials" :key="idx" class="cursor-pointer transform hover:scale-105 shadow">
        <a :href="tutorial.url">
          <img :src="imageForTutorial(tutorial)" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "TutorialVideos",
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    imageForTutorial(tutorial) {
      return sanityImageBuilder
        .image(tutorial.previewImage)
        .width(200)
        .url();
    }
  }
};
</script>

<style scoped></style>
